import { useState } from 'react';

const InputText = (props) => {
  const { type, name, placeholder, value, onChange, onBlur, validation, required } = props;

  const [text, setText] = useState('');
  const [inputActive, setInputActive] = useState(false);

  const handleChange =
    onChange ||
    ((e) => {
      setText(e.target.value);
    });
  const resolvedValue = value || text;

  const handleBlur =
    onBlur ||
    ((e) => {
      if (!e.target.value) {
        setInputActive(false);
      }
    });

  const handleFocus = () => {
    setInputActive(true);
  };

  return (
    <label htmlFor={name} className={`InputText ${inputActive ? 'is-active' : ''}`}>
      <input
        id={name}
        autoComplete="off"
        autoFocus
        placeholder={placeholder}
        value={resolvedValue}
        name={name}
        type={type || 'text'}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        data-validation={validation || null}
        data-required={required || null}
      />
    </label>
  );
};

export default InputText;
